<template>
  <RygenChip
    class="valid-ship-order-status-chip"
    :label="label"
    :severity="severity"
  />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { PlanningStatus } from '@/model/routeBuilder';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  status: {
    type: String as PropType<PlanningStatus>,
    required: true,
  },
});
const { status } = toRefs(props);

const label = computed(() => translateEnum(status.value, 'PlanningStatus'));

const severity = computed(() => {
  switch (status.value) {
    case PlanningStatus.PARTIALLY_PLANNED:
      return Severity.WARNING;
    case PlanningStatus.PLANNED:
      return Severity.SUCCESS;
    default:
      return undefined;
  }
});
</script>
